__webpack_require__.p = "/jobs-widget-state/referrals/";